import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Comprehensive Admin Dashboard
 * Main dashboard with statistics and quick access to admin functions
 */
const AdminDashboard = ({ onNavigate }) => {
  const [stats, setStats] = useState(null);
  const [reports, setReports] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const [statsResponse, reportsResponse] = await Promise.all([
        axios.get(`${API}/admin/dashboard/stats`),
        axios.get(`${API}/admin/reports/summary`)
      ]);
      
      setStats(statsResponse.data);
      setReports(reportsResponse.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleQuickAction = (tabId) => {
    if (onNavigate) {
      onNavigate(tabId);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="text-4xl mb-4">⚡</div>
          <p className="text-gray-600">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Dashboard Header */}
      <div>
        <h2 className="text-3xl font-bold text-gray-900">Admin Dashboard</h2>
        <p className="text-gray-600 mt-1">Comprehensive overview of your garbage truck tracking system</p>
      </div>

      {/* Key Statistics */}
      {stats && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Users Stats - Hidden: users managed at rideya.bz */}

          {/* Garbage Trucks Stats */}
          <div className="bg-green-50 rounded-lg p-6 border border-green-200">
            <div className="flex items-center">
              <div className="text-green-600 text-3xl mr-4">🚛</div>
              <div>
                <p className="text-sm text-green-600 font-medium">Garbage Trucks</p>
                <p className="text-2xl font-bold text-green-800">{stats.vehicles?.total || 0}</p>
                <p className="text-xs text-green-600">{stats.vehicles?.buses || 0} active trucks</p>
              </div>
            </div>
          </div>

          {/* Email Stats - Hidden */}
        </div>
      )}

      {/* Recent Activity - Hidden */}

      {/* Quick Actions */}
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-xl font-bold text-gray-900 mb-4">⚡ Quick Actions</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div
            className="text-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
            onClick={() => handleQuickAction('vehicles')}
          >
            <div className="text-3xl mb-2">🚛</div>
            <h4 className="font-medium text-gray-800">Manage Trucks</h4>
            <p className="text-xs text-gray-600 mt-1">View and edit garbage trucks</p>
          </div>

          <div
            className="text-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
            onClick={() => handleQuickAction('van-routes')}
          >
            <div className="text-3xl mb-2">🛣️</div>
            <h4 className="font-medium text-gray-800">Truck Routes</h4>
            <p className="text-xs text-gray-600 mt-1">Manage garbage truck routes</p>
          </div>

          {/* Manage Users - Hidden: users managed at rideya.bz */}

          {/* Email Logs - Hidden */}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;